import { createFileRoute } from '@tanstack/react-router';
import { type ReactNode } from 'react';
import { OffboardingHandoverPage } from '../../features/offboarding/components/handover-page';

export const Route = createFileRoute('/_app/offboarding/$userId')({
  component: OffboardingRoute,
});

/**
 * Phương án tiếp quản của một người nghỉ việc — APM-OFFB-f. Mở từ thông báo
 * "… nghỉ việc sau ngày …", khối "Cần bàn giao" ở trang chủ, hoặc dòng Nghỉ việc
 * trong hộp sửa người.
 */
function OffboardingRoute(): ReactNode {
  const { userId } = Route.useParams();
  return <OffboardingHandoverPage userId={userId} />;
}
